import { createFileRoute } from '@tanstack/react-router'
import { OrderScreen } from '@/features/orders/routes/order-screen'

export const Route = createFileRoute('/orders/$orderId')({ component: OrderPage })

function OrderPage() {
  const { orderId } = Route.useParams()
  return <OrderScreen orderId={orderId} />
}
